import React, { useState, useEffect } from 'react';
import { axios } from '../context/AuthContext';

// Read-only bildirim sayfası — veli, öğrenci ve diğer roller için
export default function OgrenciBildirimPage() {
  const [bildirimler, setBildirimler] = useState([]);
  const [loading, setLoading]         = useState(true);

  const load = async () => {
    try {
      const { data } = await axios.get('/bildirimler?limit=50');
      if (data.success) setBildirimler(data.data || []);
    } catch { }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try {
      await axios.put(`/bildirimler/${id}/oku`);
      setBildirimler(prev => prev.map(b => b.id === id ? { ...b, okundu: 1 } : b));
    } catch { }
  };

  const markAllRead = async () => {
    try {
      await axios.put('/bildirimler/hepsini-oku');
      setBildirimler(prev => prev.map(b => ({ ...b, okundu: 1 })));
    } catch { }
  };

  const TUR_ICON  = { bilgi: 'ℹ️', uyari: '⚠️', basari: '🏆', devamsizlik: '📋', hatirlatma: '⏰' };
  const TUR_COLOR = { bilgi: '#2563EB', uyari: '#E8334A', basari: '#10B981', devamsizlik: '#F59E0B', hatirlatma: '#7C3AED' };

  const okunmamis = bildirimler.filter(b => !b.okundu).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 720 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontWeight: 900 }}>🔔 Bildirimlerim</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>
            {okunmamis > 0
              ? <><span style={{ color: 'var(--accent)', fontWeight: 700 }}>{okunmamis} okunmamış</span> bildirim var</>
              : 'Tüm bildirimler okundu'}
          </p>
        </div>
        {okunmamis > 0 && (
          <button
            className="btn btn-outline btn-sm"
            onClick={markAllRead}
          >
            ✓ Tümünü Oku
          </button>
        )}
      </div>

      {/* List */}
      <div className="animate-fadeInUp" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {loading ? (
          Array(4).fill(0).map((_, i) => (
            <div key={i} className="card" style={{ padding: 16 }}>
              <div className="skeleton" style={{ height: 16, width: '60%', marginBottom: 8 }} />
              <div className="skeleton" style={{ height: 12, width: '85%' }} />
            </div>
          ))
        ) : bildirimler.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '48px 24px' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>🔔</div>
            <h3 style={{ fontFamily: 'var(--font-ui)', color: 'var(--text-muted)', fontWeight: 600 }}>Henüz bildirim yok</h3>
          </div>
        ) : bildirimler.map((b, i) => {
          const color = TUR_COLOR[b.tur] || '#2563EB';
          const icon  = TUR_ICON[b.tur]  || 'ℹ️';
          return (
            <div
              key={b.id}
              onClick={() => !b.okundu && markRead(b.id)}
              style={{
                display: 'flex', gap: 14, padding: '14px 18px',
                background: b.okundu ? 'white' : `${color}06`,
                border: `1.5px solid ${b.okundu ? 'var(--border)' : color + '25'}`,
                borderRadius: 'var(--r-lg)',
                cursor: b.okundu ? 'default' : 'pointer',
                transition: 'all 0.15s ease',
                animation: `fadeInUp 0.3s ease ${i * 40}ms both`,
                boxShadow: b.okundu ? 'var(--shadow-card)' : `0 2px 12px ${color}15`,
              }}
            >
              {/* Icon */}
              <div style={{
                width: 42, height: 42, borderRadius: 'var(--r-md)', flexShrink: 0,
                background: `${color}15`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '1.2rem',
              }}>
                {icon}
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8, marginBottom: 4 }}>
                  <div style={{
                    fontWeight: b.okundu ? 600 : 800,
                    fontSize: '0.9rem',
                    color: b.okundu ? 'var(--text-secondary)' : 'var(--text-primary)',
                    fontFamily: 'var(--font-ui)',
                  }}>
                    {b.baslik}
                    {!b.okundu && (
                      <span style={{
                        display: 'inline-block', width: 7, height: 7,
                        borderRadius: '50%', background: color,
                        marginLeft: 7, verticalAlign: 'middle',
                      }} />
                    )}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', whiteSpace: 'nowrap', flexShrink: 0 }}>
                    {new Date(b.created_at).toLocaleDateString('tr-TR', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' })}
                  </div>
                </div>
                <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
                  {b.mesaj}
                </div>
                {b.gonderen_adi && (
                  <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 5, fontWeight: 600 }}>
                    📨 {b.gonderen_adi}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
